import type { ReactNode } from 'react';

interface RankBarRowProps {
  label: ReactNode;
  value: string;
  /** Fill width 0–100 (already scaled to the set's max value). */
  pct: number;
  /** Top-ranked row uses the strong color; the rest use the lighter shade. */
  strong?: boolean;
  strongColor: string;
  lightColor: string;
}

export function RankBarRow({ label, value, pct, strong = false, strongColor, lightColor }: RankBarRowProps) {
  return (
    <div className="flex w-full flex-col gap-1.5">
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-1.5 text-caption-medium text-(--foreground-secondary-default)">
          {label}
        </span>
        <span className="shrink-0 text-caption-medium text-(--foreground-default)">{value}</span>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-(--stone-200)">
        <div
          className="h-full rounded-full transition-[width] duration-500 ease-in-out"
          style={{ width: `${pct}%`, minWidth: pct > 0 ? 6 : 0, background: strong ? strongColor : lightColor }}
        />
      </div>
    </div>
  );
}
